import React, { useRef } from 'react'
import { useFormContext } from 'react-hook-form'

import { NAVIGATION_ICONS } from '@/constants/navigationAssets'
import CommonButton from '@/components/form/Button/CommonButton'
import BtnGlobalCustomStyles from '@/components/form/Button/button.customStyles'

import { Stroker } from '../../SearchNearParking.styled'
import DateTimeControls from '../DateTimeControls/DateTimeControls'
import SearchBox from '../SearchBox'
import { SearchBoxRefHandle } from '../SearchBox'

import { OptionsWrapper } from './Options.styled'

const DesktopSearch = ({
  market,
  placeholder,
  translatedSearchBtn
}: {
  market: string
  placeholder: string
  translatedSearchBtn: string
}) => {
  const { getValues } = useFormContext()
  const searchBoxRef = useRef<SearchBoxRefHandle>(null)

  const handleSearchClick = () => {
    if (searchBoxRef.current) {
      searchBoxRef.current.selectFirstOption()
    }
  }

  return (
    <OptionsWrapper data-test-id="options-wrapper">
      <SearchBox market={market} placeholder={placeholder} ref={searchBoxRef} />
      <Stroker />
      <DateTimeControls />
      <CommonButton
        variant="searchWrapper"
        type="submit"
        data-test-id="search-button-wrapper"
        customStyle={BtnGlobalCustomStyles.searchWrapper}
        onClick={handleSearchClick}
      >
        <img src={NAVIGATION_ICONS.search} alt="Search" loading="lazy" />
        <span>{translatedSearchBtn}</span>
      </CommonButton>
    </OptionsWrapper>
  )
}

export default DesktopSearch
